import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@material-ui/core';
import Link from 'next/link';
import React from 'react';
import { FormInputs } from '../Register';
import { Button, FormikValues, Label, TextField } from '../../formikFormInputs';
import { REQUIRED } from '../../../utils/validation';

export default ( { handleClose, submit }: any) => {
  const emailField = [
    {
      name: "email",
      label: <Label label={"Your email"}/>,
      type: "email",
      component: TextField,
      rowSize: 12
    }
  ]

  return (
    <Formik
      initialValues={{email: ''}}
      onSubmit={submit}
      validationSchema={Yup.object({
        email: Yup.string().required(REQUIRED)
      })}>
      {({ isSubmitting, errors, values, touched, handleChange, handleBlur }: FormikValues) => (
        <Form>
          <FormInputs
            fields={emailField}
            {...{errors, values, touched, handleChange, handleBlur}}
          />

          <Grid container justifyContent="space-between" alignItems="center" style={{ margin: "20px 0px"}} >
            <Link href="/agent-resources">
              <a onClick={handleClose}>Back to Login</a>
            </Link>
            <Button
              color="primary"
              disabled={isSubmitting}
              label="Reset Password"
              size="medium"
              type="submit"
              variant="contained"
            />
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
